class ProductVariants extends window.HTMLElement {
  constructor () {
    super()
    this.variants = this.querySelectorAll('.js-variant')
    this.label = this.querySelector('.js-label')
    const events = ['mouseover', 'focus']

    events.forEach(event => this.variants.forEach(variant => (
      variant.addEventListener(event, this.setActiveLabel.bind(this))
    )))
  }

  setActiveLabel ({ currentTarget }) {
    this.label.innerText = currentTarget.dataset.title
  }
}

window.customElements.define('product-variants', ProductVariants)
